import React from 'react'
import { DefaultHomepageData } from '@/scenes'
import BaseHomepage from './homepage'

const Homepage = () => <BaseHomepage data={DefaultHomepageData} service={'default'}/>

export default Homepage

export * from './homepage'
